import React from 'react';
import {
  ArrayInput,
  BooleanInput,
  Edit,
  NumberInput,
  SelectInput,
  SimpleForm,
  SimpleFormIterator,
  WithRecord,
} from 'react-admin';
import SpecialtyInput from 'components/SpecialtyInput';
import EhrSystemInput from 'components/EHRSystemInput';
import MoneyInput from 'components/MoneyInput';

const PoolsEdit = () => {
  const transform = (data) => {
    const orientation_shifts = data.orientation_shifts?.map((o_s) => ({
      shifts_required: o_s.shifts_required,
      shift_type: o_s.shift_type,
      pay_rate_cents: o_s.pay_rate_cents,
    }));
    const pool = {
      specialty_ids: data.specialty_ids,
      ehr_system_id: data.ehr_system_id,
      shift_needs: data.shift_needs,
      requires_pro_review: data.requires_pro_review,
      pool_orientation_shifts_attributes: orientation_shifts,
    };
    return pool;
  };
  return (
    <Edit mutationMode="pessimistic" transform={transform}>
      <WithRecord
        render={(record) => (
          <SimpleForm
            defaultValues={{
              ...record,
              position_ids: record.positions?.map((p) => p.id),
              specialty_ids: record.specialties?.map((s) => s.id),
              ehr_system_id: record.ehr_system?.id,
            }}
          >
            <SpecialtyInput multiple positionSource="position_ids" filter={{ active: true }} />
            <EhrSystemInput />
            <SelectInput
              source="shift_needs"
              choices={[
                { name: '1-5', id: 'needs_1_5' },
                { name: '6-10', id: 'needs_6_10' },
                { name: '11-20', id: 'needs_11_20' },
                { name: '20+', id: 'needs_20_plus' },
              ]}
            />
            <BooleanInput source="requires_pro_review" />
            <ArrayInput source="orientation_shifts">
              <SimpleFormIterator>
                <SelectInput
                  source="shift_type"
                  choices={[
                    { name: 'General', id: 'general_orientation' },
                    { name: 'In Unit', id: 'in_unit' },
                    { name: 'Shadow', id: 'shadow' },
                    { name: 'Combined (General + Shadow)', id: 'combined' },
                  ]}
                />
                <NumberInput source="shifts_required" />
                <MoneyInput source="pay_rate_cents" />
              </SimpleFormIterator>
            </ArrayInput>
          </SimpleForm>
        )}
      />
    </Edit>
  );
};

export default PoolsEdit;
